import React, {useState, useEffect} from 'react'
import {getAllDepartment} from "../../services/serviceDepartment";
import {createEmployee} from "../../services/serviceEmployee";
import {Form, Modal, Input, Select, Button, DatePicker} from "antd";
import bcrypt from "bcryptjs"
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}
const dateFormat = 'DD/MM/YYYY'

const EmployeeCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [departments, setDepartments] = useState({})
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllDepartment()
            .then(({data}) => setDepartments(data))
    }, [])

    const getHashPassword = async(value) => {
        const password = await bcrypt.hash(value, 10)
        return new Promise(resolve => resolve(password))
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let request= {
            name: list.employeeName,
            surname: list.employeeSurname,
            employeeCode: list.employeeCode,
            username: list.employeeUsername,
            department: list.employeeDepartment,
            birthdate: list.birthDate,
            phoneNumber: list.phoneNumber,
            internalPhoneCode: list.internalPhoneCode,
            title: list.title
        }
        getHashPassword(list.employeePassword)
            .then(data => {
                request.password = data
                createEmployee(request)
                    .then(() => {
                        exitLoadingState(setLoadings)
                        modalCloser()
                        updater()
                    })
                    .catch(() => exitLoadingState(setLoadings))
            })
    }

    return(
        <React.Fragment>
            <Modal
                title={'Çalışan Ekle'}
                open={show}
                closable={false}
                footer={[
                    <Button type={'primary'} key={'SubmitButton'} loading={loadings[0]} onClick={()=>form.submit()}>Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={modalCloser}>Kapat</Button>
                ]}

            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item
                        label={'Adı'}
                        name={'employeeName'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Soyadı'}
                        name={'employeeSurname'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'employeeCode'}
                        label={'Çalışan Kodu'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'},
                            {min:2, message: 'En az 2 Karakter Girmek Zorunludur'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Departmanı'}
                        name={'employeeDepartment'}
                    >
                        <Select >
                            {Object.keys(departments).map( (key) =>{
                                let item = departments[key]
                                return <Select.Option key={key} value={item.id}>{item.code}</Select.Option>
                            }  )}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={'title'}
                        label={'Ünvan'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'birthDate'}
                        label={'Doğum Tarihi'}
                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        name={'phoneNumber'}
                        label={'Telefon Numarası'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'internalPhoneCode'}
                        label={'Dahili'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Kullanıcı Adı'}
                        name={'employeeUsername'}
                        rules={[
                            {required: true, message: 'Kullanıcı Adı Alanı Boş Bırakılamaz'},
                            {type: 'email', message: 'Doğru Bir Formatte E-mail Giriniz (örnek@örnek.com)'}
                        ]}
                    >
                        <Input  />
                    </Form.Item>
                    <Form.Item
                        label={'Şifresi'}
                        name={'employeePassword'}
                        rules={[
                            {min: 4, message: 'Şifreniz En Az 4 Karakterden Oluşmalıdır'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Form>

            </Modal>
        </React.Fragment>
    )
}
export default EmployeeCreate